module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh":{"sketchTitle":"选择颜色"},"en":{"sketchTitle":"Select Color"},"jp":{"sketchTitle":"色を選択"},"de":{"sketchTitle":"Farbe auswählen"},"fr":{"sketchTitle":"Sélectionner la couleur"},"es":{"sketchTitle":"Selecciona el color"},"pt":{"sketchTitle":"Selecionar Cor"},"it":{"sketchTitle":"Seleziona Colore"},"tw":{"sketchTitle":"選擇顏色"}}')
  delete Component.options._Ctor
}
